import { ResendPartnerOnboardingCollaboratorInviteRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useResendOnboardingCollaboratorInvite() {
  const [resendingOnboardingCollaboratorInvite, setResendingOnboardingCollaboratorInvite] = useState(false);

  async function resendOnboardingCollaboratorInvite(params: ResendPartnerOnboardingCollaboratorInviteRequest) {
    try {
      setResendingOnboardingCollaboratorInvite(true);
      const res = await api.resendPartnerOnboardingCollaboratorInvite(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setResendingOnboardingCollaboratorInvite(false);
    }
  }

  return { resendingOnboardingCollaboratorInvite, resendOnboardingCollaboratorInvite };
}
